import { AbstractControl } from '@angular/forms';

export function BudgetFinansiarRequired(rowId: string) {
  return (control: AbstractControl) => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const anyNonZeroInFinansiarRow = parsedValue
        .filter((pv) => pv.rowId === rowId)
        .some((pv) => pv.value && pv.value > 0);

      if (anyNonZeroInFinansiarRow) {
        return;
      }
    }
    return { [`BudgetFinansiarRequired_${rowId}`]: true };
  };
}
